<template>
  <div class="home page">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-monitor-dashboard</v-icon>
      ادارة العروض 
      <back-button />
    </h2>
    <hr class="my-5 header-divider" />

    <!-- CREATE / UPDATE FROM -->
    <record-form />

    <!-- UPDATE / NEW RECORD -->
    <filters-box @fetch="fetchRecords({ page: 1 })" />
    <div class="mb-3 mt-9 text-left">

      <v-btn
        large
        color="primary"
        elevation="0"
        @click="
          SET_FORM_RECORD({});
          SET_EDIT_MODE(false);
          SHOW_FORM();
        "
      >
        اضافة عرض جديد
        <v-icon class="mr-2">mdi-plus</v-icon>
      </v-btn>
    </div>
      <v-chip right class="mb-2" label color="secondary">
        <v-icon> mdi-account-circle-outline </v-icon> عدد العروض
        {{ total_offers }}</v-chip
      >
    <!-- TABLE -->
    <v-data-table
      item-key="id"
      class="elevation-1"
      :loading="table.loading"
      :headers="table.headers"
      :items="records"
      loading-text="Downloading Data"
      no-data-text="No Data"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
    >

    <template v-slot:item.image="{ item }">
        <img :src="item.image" width="50px" class="mt-3 mb-2 rounded-lg" />
      </template>
      <template v-if="item && item.start_date" v-slot:item.start_date="{ item }">
        {{ new Date(item.start_date).toLocaleTimeString([],  { year: 'numeric', month:'2-digit' , day:'2-digit', hour: '2-digit', minute: '2-digit' , timeZone:Intl.DateTimeFormat().resolvedOptions().timeZone}) }}
      </template>
      <template v-if="item && item.start_date" v-slot:item.end_date="{ item }">
        {{ new Date(item.end_date).toLocaleTimeString([],  { year: 'numeric', month:'2-digit' , day:'2-digit', hour: '2-digit', minute: '2-digit' , timeZone:Intl.DateTimeFormat().resolvedOptions().timeZone}) }}
      </template>
      <!-- CONTROLS -->
      <template v-slot:item.controls="{ item }">
        <v-btn
          small
          icon
          color="secondary"
          class="mx-1"
          @click="
            SET_FORM_RECORD(item);
            SET_EDIT_MODE(true);
            SHOW_FORM();
          "
        >
          <v-icon>mdi-circle-edit-outline</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.blocked="{ item }">
        <v-switch
          v-if="item.active == 0"
          inset
          :input-value="false"
          @change="unblock(item)"
        ></v-switch>
        <v-switch
          v-else="item.active == 1"
          color="success"
          inset
          :input-value="true"
          @change="block(item)"
        ></v-switch>
      </template>
    </v-data-table>

    <!-- PAGINATION -->
    <div class="text-center mt-7">
      <v-pagination
        total-visible="7"
        @input="$router.replace({ query: { ...$route.query, page: $event } })"
        :value="parseInt(filters.page)"
        :length="totalPages"
        circle
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import RecordForm from "./RecordForm";
import { mapState, mapMutations } from "vuex";
import FiltersBox from "./FiltersBox.vue";
export default {
  name: "offers",
  components: { RecordForm,  FiltersBox},

  data: function () {
    return {
      // table
      table: {
        headers: [
          {
            value: "country",
            text: "الدولة",
          },
          {
            value: "section",
            text: "القسم",
          },
          {
            value: "start_date",
            text: "تاريخ البداية",
          },
          {
            value: "end_date",
            text: "تاريخ انتهاء العرض",
          },
          {
            value: "image",
            text: "الصورة",
          },
          {
            value: "watched",
            text: "المشاهدة",
          },
          {
            value: "blocked",
            text: "تفعيل/تعطيل",
          },
          {
            value: "controls",
            text: "تعديل",
          },
        ],
        loading: false,
      },
    };
  },

  computed: {
    ...mapState("offers", ["records", "page", "totalPages", "filters" , "total_offers"]),
  },
  watch: {
    $route: {
      async handler(route) {
        if (!route.query.page) {
          await this.$router.replace({ query: { ...route.query, page: 1 } });
          return;
        }

        this.SET_FILTERS({ ...route.query });
        this.fetchRecords(route.query);
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapMutations("offers", [
      "SHOW_FORM",
      "SET_EDIT_MODE",
      "SET_FORM_RECORD",

      "SHOW_RECORD_FORM",

      "SET_FILTERS",
    ]),

    fetchRecords() {

      this.table.loading = true;
      // // console.log(page);
      this.$store
        .dispatch("offers/fetchRecords")
        .catch((error) => {
          this.$bus.$emit("showSnackbar", {
            text: "Error while getting Data",
            color: "accent",
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    async unblock(selectedRecord) {
      this.table.loading = true;

      await this.$store
        .dispatch("offers/unblock", { record: { ...selectedRecord } })
        .then(() => {
          this.$bus.$emit("showSnackbar", {
            text: ` تم فك حظر العرض`,
            color: "success",
          });
          this.fetchRecords();
        })
        .catch((error) => {
          this.$bus.$emit("showSnackbar", {
            text: "Error while unblocking Admin  ",
            color: "red darken-3",
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    async block(selectedRecord) {
      this.table.loading = true;

      await this.$store
        .dispatch("offers/block", { record: { ...selectedRecord } })
        .then(() => {
          this.$bus.$emit("showSnackbar", {
            text: `تم حظر العرض`,
            color: "warning",
          });
          this.fetchRecords();
        })
        .catch((error) => {
          this.$bus.$emit("showSnackbar", {
            text: " Error while blocking Admin",
            color: "red darken-3",
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
  },
};
</script>
